import { getElementByIriFromArr } from "../../../../../../shared/lib";

export const isSuperVisorField = (users,electedUser) =>{
    
    if(electedUser){
        const userObject = getElementByIriFromArr(electedUser,users)
        if(userObject && userObject.roles.includes("ROLE_MOD"))return true
    }

    return false
}